"use strict";

angular.module("core")
.controller("Profile", function(
    $scope, $rootScope, $state, $resource, $timeout, FlashBag, gettextCatalog, FormError, Language, UserService,
    PatternService, ProfileService, appConfig, CUSTOMER_TYPE, EMAIL_MAXLENGTH
) {
    var _this = this;
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.pattern = PatternService;
    $scope.app = appConfig.APP;
    $scope.isPasswordCollaspse = true;
    $scope.timeZones = $resource(appConfig.API_SERVER + "/auth/time-zones/").query();
    $scope.Form = ProfileService.getProfile();

    $scope.isCustomerTypeBusiness = true;
    $scope.msgCreateFamilyMemberUser = gettextCatalog.getString("To manage another house with the same user account, please contact support.");
    UserService.isUserFetched().then(function onSuccess(user) {
        $scope.isCustomerTypeBusiness = !!user && user.customer && user.customer.type === CUSTOMER_TYPE["BUSINESS"];
    });

    $scope.Form.$promise.then(function onSuccess() {
        _this.initPasswordFields();
    },
    function onError(response) {
        FlashBag.apiError(response);
    });

    this.validate = function($event) {
        $event.preventDefault();
        FlashBag.clearAll();

        if (!$scope.FormProfile.$valid) {
            $scope.isSubmit = true;
            FormError.focus("FormProfile");
        }
        else {
            submit();
        }
    };

    this.initPasswordFields = function() {
        $timeout(function() {
            var inputNewPasswords = document.getElementsByName("NewPassword");
            if (inputNewPasswords && inputNewPasswords[0]) {
                var inputNewPassword = inputNewPasswords[0];
                inputNewPassword.value = "";
                angular.element(inputNewPassword).triggerHandler("input");
                angular.element(inputNewPassword).triggerHandler("change"); // Added to fix issue with IE11
            }

            var inputConfirmPasswords = document.getElementsByName("ConfirmNewPassword");
            if (inputConfirmPasswords && inputConfirmPasswords[0]) {
                var inputConfirmPassword = inputConfirmPasswords[0];
                inputConfirmPassword.value = "";
                angular.element(inputConfirmPassword).triggerHandler("input");
                angular.element(inputConfirmPassword).triggerHandler("change"); // Added to fix issue with IE11
            }
        });
    };

    this.toggle = function() {
        $scope.isPasswordCollaspse = !$scope.isPasswordCollaspse;
        this.initPasswordFields();
    };

    $scope.$on("submitFormProfileUpdate", function(event, data) {
        if (data && data["password"]) {
            $scope.Form.password = data["password"];
        }
        saveProfile();
    });

    function submit() {
        if ($scope.FormProfile.NewPassword.$viewValue || $scope.FormProfile.Email.$dirty || $scope.FormProfile.CellPhone.$dirty) {
            $scope.$broadcast("confirmPasswordProfileUpdate");
        } else {
            saveProfile();
        }
    }

    function saveProfile() {
        ProfileService.saveProfile($scope.Form)
        .then(function onSuccess(data) {
            $scope.isSubmit = false;
            Language.set(data.LanguageID);
            _this.initPasswordFields();
            FlashBag.success(gettextCatalog.getString("The profile was updated successfully."), true);
            $scope.$broadcast("formSubmissionSucceededProfileUpdate");
            UserService.setModified().then(function onSuccess() {
                if ($rootScope.fromState && $rootScope.fromState.name) {
                    $state.go($rootScope.fromState, $rootScope.fromParams || {});
                } else {
                    $state.go("home");
                }
            });
        },
        function onError(response) {
            $scope.$broadcast("formSubmissionFailedProfileUpdate", response, true);
            FlashBag.apiError(response);
        });
    }

    $scope.$on("submitFormProfileDelete", function(event, data) {
        var password;
        if (data && data["password"]) {
            password = data["password"];
        }
        confirmProfileDelete(password);
    });

    this.deleteProfile = function() {
        $scope.$broadcast("confirmPasswordProfileDelete");
    };

    function confirmProfileDelete(password) {
        ProfileService.deleteProfile(password).then(function onSuccess() {
            FlashBag.success(gettextCatalog.getString("The profile was deleted successfully."), true);
            $scope.$broadcast("formSubmissionSucceededProfileDelete");
            UserService.clearTokenAndUser();
            $state.go("login");
        },
        function onError(response) {
            $scope.$broadcast("formSubmissionFailedProfileDelete", response, true);
            FlashBag.apiError(response);
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/profile/profile.controller.js
// module id = 402
// module chunks = 0